// extracted by mini-css-extract-plugin
export default {"waitingContainer":"WaitForHost_waitingContainer__4kGsS","leaveButton":"WaitForHost_leaveButton__ftkdl"};